import { DeleteAllHistoryModal} from "./DeleteAllHistoryModal";

export default DeleteAllHistoryModal;
